import { HTMLAttributes } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import ProductDto from "@/application/dto/ProductDto";
import { ProductDescription } from "@/page/Checkout/style";
import {
  ProductBuyNow,
  ProductCard,
  ProductCardContent,
  ProductCardFooter,
  ProductCardHeader,
  ProductCardMoreInfo,
  ProductImage,
  ProductPrice,
  ProductPriceCurrentContainer,
  ProductPricePreviousContainer,
  ProductTitle
} from "./styles";

interface ProductItemProps extends HTMLAttributes<HTMLDivElement> {
  product: ProductDto;
  companiesSlug: string;
  onClickMoreInfo: (product: ProductDto) => void;
}

const ProductItem = ({ product, companiesSlug, onClickMoreInfo, ...rest }: ProductItemProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <ProductCard {...rest}>
      <ProductImage src={product.image} />
      <ProductCardContent>
        <ProductCardHeader>
          <ProductTitle title={product.name}>
            <h3>{product.name}</h3>
            <small>{product.type}</small>
          </ProductTitle>
          <ProductPrice>
            {product?.pricePrevious && (
              <ProductPricePreviousContainer>
                <p>de</p>
                <p>
                  {Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(product?.pricePrevious)}
                </p>
              </ProductPricePreviousContainer>
            )}
            <ProductPriceCurrentContainer>
              <p>por</p>
              <p>
                {Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(product.priceCurrent || 0)}
              </p>
            </ProductPriceCurrentContainer>
          </ProductPrice>
        </ProductCardHeader>
        <ProductDescription>
          <span className="font-regular">{product.description}</span>
        </ProductDescription>
        <ProductCardMoreInfo>
          <button onClick={() => onClickMoreInfo(product)}>
            Mais informações <span className="material-icons md-18" style={{ marginTop: '2px' }}>chevron_right</span>
          </button>
        </ProductCardMoreInfo>
      </ProductCardContent>
      <ProductCardFooter>
        <ProductBuyNow
          onClick={() => {
            navigate(`/${companiesSlug}/checkout/customer`, {
              state: {
                product,
                from: location.pathname
              },
            });
          }}
        >
          Comprar agora
        </ProductBuyNow>
      </ProductCardFooter>
    </ProductCard>
  );
};

export default ProductItem;
